<template>
    <div class="container">
        <div class="download">
            <!-- <div class="title">
                <div class="active">产品下载</div>
                <div>产品分类</div>
                <div>委托合成</div>
                <div>质量控制</div>
                <div>检测报告下载指南</div>
                <div>产品标签和密度说明</div>
            </div>-->
            <el-card>
                <div class="item" v-for="(val, index) in list" :key="index">
                    <div class="item-title">{{val.year}}新产品下载</div>
                    <ul>
                        <li v-for="(item, i) in val.list" :key="i">
                            <a :href="item.fileUrl" target="_blank">{{item.fileName}}</a>
                        </li>
                    </ul>
                </div>
            </el-card>
        </div>
        <Hot></Hot>
    </div>
</template>

<script>
import Hot from '../components/hot/Hot';

import * as apis from '../fetch/common';

export default {
    name: 'download',
    components: {
        Hot,
    },
    data() {
        return {
            list: [],
        };
    },
    methods: {
        getProInfoFile() {
            apis.getProInfoFile().then(res => {
                this.list = res;
            });
        },
    },
    mounted() {
        this.getProInfoFile();
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}
.download {
    width: 892px;
    .title {
        width: 892px;
        height: 50px;
        background-color: #ebebeb;
        border-radius: 25px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        div {
            line-height: 50px;
            padding: 0 16px;
            border-radius: 33px;
            color: #575757;
            cursor: pointer;
        }
        .active {
            color: #fff;
            background-image: linear-gradient(90deg, #6db231 0%, #37923a 100%);
        }
    }
    .item {
        .item-title {
            display: inline-block;
            font-size: 16px;
            line-height: 50px;
            padding: 0 40px;
            color: #fff;
            background-image: linear-gradient(90deg, #6db231 0%, #37923a 100%);
            box-shadow: 0 3px 1px 2px #217b31;
            margin-left: -20px;
            border-radius: 0 25px 25px 0;
        }
        ul {
            list-style: none;
            padding-left: 20px;
            li {
                line-height: 40px;
                a {
                    color: #2b2b2b;
                }
            }
        }
    }
}
</style>